export default import.meta.ROLLDOWN_FILE_URL_utzVEx8tbsUGwI0_CVNAOw